// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"895":"896f00c5","998":"144dfee1"}[chunkId] + ".chunk.css";
};